import { Image } from 'react-native';

import LightFoundationImages from '@vfgroup-oneplatform/foundation/Components/Themes/Modes/Light/Images';

import Images from '../../Images';

const images = {
  ...LightFoundationImages,
  ...Images,

  ic_chevron_left_black_white: Image.resolveAssetSource(
    require('../../../Assets/Images/icChevronLeftBlack.png'),
  ),
  ic_chevron_right_black_white: Image.resolveAssetSource(
    require('../../../Assets/Images/icChevronRightBlack.png'),
  ),
  active_store_marker: Image.resolveAssetSource(require('../../../Assets/Images/storeMarker.png')),
  store_marker: Image.resolveAssetSource(require('../../../Assets/Images/blue_dot.png')),
  ic_shop: Image.resolveAssetSource(require('../../../Assets/Images/icShopBlack.png')),
  ic_payment_red: Image.resolveAssetSource(require('../../../Assets/Images/icPaymentRed.png')),
  ic_home: Image.resolveAssetSource(require('../../../Assets/Images/icHome.png')),
  edit_pen: Image.resolveAssetSource(require('../../../Assets/Images/account_settings_edit.png')),
  edit_pen_two: Image.resolveAssetSource(require('../../../Assets/Images/icEditRed.png')),
  ic_delete: Image.resolveAssetSource(require('../../../Assets/Images/icDeleteRed.png')),
  ic_delete_two: Image.resolveAssetSource(require('../../../Assets/Images/icDeleteRed2.png')),
  ic_bulb: Image.resolveAssetSource(require('../../../Assets/Images/ic_bulb.png')),
  icCvv: Image.resolveAssetSource(require('../../../Assets/Images/icCvv.png')),
  ic_remove: Image.resolveAssetSource(require('../../../Assets/Images/icRemove.png')),
  ic_add_red: Image.resolveAssetSource(require('../../../Assets/Images/icAdd.png')),
  ic_rearrange: Image.resolveAssetSource(require('../../../Assets/Images/icRearrange.png')),
  icHalfHashedCircle: Image.resolveAssetSource(require('../../../Assets/Images/icDarkmode.png')),
  icCalendarRed: Image.resolveAssetSource(require('../../../Assets/Images/icCalendarRed.png')),
  icDemmedRemove: Image.resolveAssetSource(require('../../../Assets/Images/icDemmedRemove.png')),
  dashboard_options_number1: Image.resolveAssetSource(
    require('../../../Assets/Images/number-1.png'),
  ),
  dashboard_options_number2: Image.resolveAssetSource(
    require('../../../Assets/Images/number-2.png'),
  ),
  icBiometricAuthentication: Image.resolveAssetSource(
    require('../../../Assets/Images/biometric-authentication.png'),
  ),
  icon_bill_report_generic: Image.resolveAssetSource(
    require('../../../Assets/Images/payment_offers_bill.png'),
  ),
  ic_compare_plans: Image.resolveAssetSource(require('../../../Assets/Images/icBundlesRed.png')),
  icAdminRed: Image.resolveAssetSource(require('../../../Assets/Images/icAdminRed.png')),
  dataSharing: Image.resolveAssetSource(require('../../../Assets/Images/dataSharing.png')),
  ic_voucher_camera_button: Image.resolveAssetSource(
    require('../../../Assets/Images/ic_camera.png'),
  ),
  ic_voucher_qr_button: Image.resolveAssetSource(require('../../../Assets/Images/qr_code.png')),
  ic_voucher_top_up: Image.resolveAssetSource(require('../../../Assets/Images/top_up.png')),
};

export default images;
